import { createApp } from '@app/adapters/create-app'
import AutomaticallyFollowedBanner from '@app/application/workflows/components/automatically-followed-banner.vue'

window.onDomLoad(($dom) => {
  const doc = $dom[0]
  const elements = doc.querySelectorAll<HTMLElement>(
    '[data-behaviour="automatically-followed-banner"]'
  )

  elements.forEach((element) => {
    const data = element.dataset

    const automaticallyFollowedBannerApp = createApp(
      AutomaticallyFollowedBanner,
      {
        supportArticleUrl: data.supportArticleUrl,
      }
    )

    automaticallyFollowedBannerApp.mount(element)
  })
})
